import { produce } from "immer";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const initUrl = {
  urls: [],
};

interface UrlState {
  urls: string[];
}

interface Store extends UrlState {
  addUrl: (payload: string) => void;
  deleteUrl: (payload: string) => void;
}

export const useUrlStore = create<Store>()(
  persist(
    (set) => ({
      ...initUrl,
      addUrl: (payload: string) =>
        set(
          produce((state: UrlState) => {
            state.urls.push(payload);
          })
        ),
      deleteUrl: (payload: string) =>
        set(
          produce((state: UrlState) => {
            state.urls = state.urls.filter((url) => url !== payload);
          })
        ),
    }),
    {
      name: "my-url-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
